import { LegalContents } from '@chegg-wt/core/types/core'

export const legalContents: LegalContents = {
  commitment:
    'Serving High School, College, and University students, their teachers, and independent researchers since 2000.',
  copyright: 'Copyright © 2000 - 2020 by Citation Machine®, a Chegg Service.',
  tagline:
    'Citation Machine® uses the 9th ed. of MLA, 7th ed. of APA, and 17th ed. of Chicago (9th ed. Turabian).',
}
